// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import ProjectMenu from './Project'
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectMa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (

            <div className={`flex-col`}>
                <Header activeMenu='6' />
                <div className='dv_project_body'>
                    <ProjectMenu activeMenu={1} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/projects/1.png")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>走进马来西亚</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>研究型硕士学术服务</div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>研究型博士学术服务</div>
                                    <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>哲斯顿大学学院</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body'>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/2.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/3.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/4.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/5.png")} /></div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body'>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/6.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/7.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/8.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/9.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/10.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/11.png")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/39.jpg")} /></div>

                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body'>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/40.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/41.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/42.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/43.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/44.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/45.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/46.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/47.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/48.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/49.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/50.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/51.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/52.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/53.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/54.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/55.jpg")} />
                                    </div>
                                    <div>
                                        <LazyImage imgUrl={require("./assets/img/projects/56.jpg")} />
                                    </div>
                                </div>}
                                {this.state.currentTab == 3 && <div className='dv_lazy_body'>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/57.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/58.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/59.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/60.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/61.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/62.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/63.jpg")} /></div>
                                    <div><LazyImage imgUrl={require("./assets/img/projects/64.jpg")} /></div>

                                </div>}
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>


        );
    }
}

export default withRouter(ProjectMa);